import { render } from "./img-swiper.vue?vue&type=template&id=0c866715"
import script from "./img-swiper.vue?vue&type=script&lang=js"
export * from "./img-swiper.vue?vue&type=script&lang=js"

import "./img-swiper.vue?vue&type=style&index=0&id=0c866715&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/img-swiper.vue'],['render',render],['__file',"img-swiper.vue"]])

export default __exports__